import React, { FC } from 'react'

import { IconVideoProps } from './IconVideo.types'
import * as Styled from './styles/IconVideo.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVideo: FC<IconVideoProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVideoProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconVideoProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M157.38 38.73a8.94 8.94 0 0 0-6.38-2.65 9 9 0 0 0-6.32 2.59L124 58.59V40a16 16 0 0 0-16-16H16A16 16 0 0 0 0 40v80a16 16 0 0 0 16 16h92a16 16 0 0 0 16-16v-18.6l20.63 19.85a8.94 8.94 0 0 0 6.37 2.65 8.94 8.94 0 0 0 6.36-2.63 9.06 9.06 0 0 0 2.64-6.37V45.1a8.94 8.94 0 0 0-2.62-6.37zM152 114.9a1 1 0 0 1-.29.71 1 1 0 0 1-.71.29 1 1 0 0 1-.77-.35l-27.46-26.43A4 4 0 0 0 116 92v28a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V40a8 8 0 0 1 8-8h92a8 8 0 0 1 8 8v28a4 4 0 0 0 6.78 2.88l27.52-26.51a1 1 0 0 1 .71-.29 1 1 0 0 1 1 1z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconVideo
